import QuestionCreationForm from "pages/QuestionPage/questionCreation/QuestionCreationForm/QuestionCreationForm";

export default QuestionCreationForm;
